import React from 'react';
import { PerkIcon } from './PerkIcon';
import type { Perk } from '../types/eventBookingCategoryTypes';

interface PerkCardProps {
  perk: Perk;
  className?: string;
}

export const PerkCard: React.FC<PerkCardProps> = ({ perk, className = "" }) => {
  return (
    <div 
      className={`flex flex-col items-center justify-center p-1.5 sm:p-3 rounded-xl bg-[#111111] border border-white/5 shadow-lg w-[62px] sm:w-[100px] aspect-[4/5] text-center gap-1 sm:gap-3 flex-shrink-0 transition-transform hover:scale-105 ${className}`}
    >
      <PerkIcon 
        icon={perk.icon} 
        className="w-7 h-7 sm:w-10 sm:h-10 text-gray-200" 
      />
      <span className="text-[8px] sm:text-[11px] font-black leading-tight text-gray-300 uppercase tracking-wider">
        {perk.name}
      </span>
    </div>
  );
};
